const sliderText = [
  {
    headingInnovation: "Innovation",
    textInnovation:
      "We are focused, we seek and develop long term relationships with our customers, partners, employees, and this is the way of our business development.",
    headingPartnership: "Partnership",
    textPartnership:
      "We are focused, we seek and develop long term relationships with our customers, partners, employees, and this is the way of our business development.",
    headingQuality: "Quality and environment",
    textQuality:
      "We implement and continuously improve the integrated quality and environmental management system in accordance with ISO 9001:2008 and ISO 14001:2004. We focus on daily operations with minimal environmental impact.",
  },
  {
    headingInnovation: "Inovatyvumas",
    textInnovation:
      "Naujų  galimybių ir sprendimų paieška produktyvumo didinimui ir sąnaudų mažinimui pateikiant klientui tik pačius geriausius pasiūlymus.",
    headingPartnership: "Partnerystė",
    textPartnership:
      "Orientuojamės, siekiame ir ugdome ilgalaikius santykius su klientais, partneriais, darbuotojais, tai mūsų įmonės veiklos plėtros kelias.",
    headingQuality: "Kokybė ir aplinkosauga",
    textQuality:
      "Įdiegėme ir nuolat tobuliname integruotą kokybės bei aplinkosaugos vadybos sistemą atitinkančią ISO 9001:2008 ir ISO 14001:2004 standartus. Siekiame kiek įmanoma sumažinti neigiamą poveikį aplinkai.",
  },
  {
    headingInnovation: "Innowacyjność",
    textInnovation:
      "Poszukiwanie nowych możliwości i rozwiązań w celu zwiększenia wydajności oraz obniżenia kosztów, oferując klientom wyłącznie najlepsze rozwiązania.",
    headingPartnership: "Partnerstwo",
    textPartnership:
      "Orientujemy się na długotrwałe relacje z klientami, partnerami, pracownikami oraz dążymy do ich utrzymania. Jest to droga rozwoju działalności naszej firmy.",
    headingQuality: "Jakośc i ochrona srodowiska",
    textQuality:
      "Wdrożyliśmy i stale doskonalimy zintegrowany system zarządzania jakością i środowiskiem zgodny z normami ISO 9001:2008 oraz ISO 14001:2004. Nastawieniem na maksymalne zmniejszenie negatywnego wpływu na środowisko.",
  },
];

export default sliderText;
